import { type App } from 'vue'
import FaIcon from './fa-icon.vue'
import FormHeader from './form-input/form-header.vue'
import HeaderBanner from './header-banner.vue'
import SectionForm from './section-form.vue'
import SidebarNav from './sidebar-nav.vue'
import SummaryPanel from './summary-panel.vue'
import SummaryPanelMobile from './summary-panel-mobile.vue'

export default {
  install (app: App) {
    app.component('FaIcon', FaIcon)
    app.component('SectionForm', SectionForm)
    app.component('FormHeader', FormHeader)
    app.component('HeaderBanner', HeaderBanner)
    app.component('SidebarNav', SidebarNav)
    app.component('SummaryPanel', SummaryPanel)
    app.component('SummaryPanelMobile', SummaryPanelMobile)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    FaIcon: typeof FaIcon,
  }
}
